import { UserRole } from 'softcat:config/user-role.ts';

const AccessTokenStorageKey = 'SOFTCAT_ACCESS_TOKEN';

const RoleHierarchy = {
    [UserRole.ADMIN]: 3,
    [UserRole.SUPERADMIN]: 4,
    [UserRole.UPLOADER]: 1,
    [UserRole.USER]: 2,
};

const AuthErrors = {
    INSUFFICIENT_PERMISSIONS: 'insufficient_permissions',
    UPLOADER_ROLE: 'uploader_role',
} as const;

export const AuthConfig = {
    AccessTokenStorageKey,
    AuthErrors,
    RoleHierarchy,
};
